import { Inject, Injectable } from '@angular/core';
import { QuickButtonsModel } from '@fh-client-interaction-frontends/quick-buttons';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { SharedFeaturesService } from '@fh-client-interaction-frontends/fh-providers';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CpLoggedUserInfoModel } from '../../helpers/objects/dto/logged-user-info/cp-logged-user-info-model';

@Injectable({
  providedIn: 'root'
})
export class CpUsersService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  listButtons: QuickButtonsModel[] = [];

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private sharedFeaturesService: SharedFeaturesService, private http: HttpClient) {
    this.appConfig = appConfigTemp;
    this.listButtons = [
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-book-medical',
        title: 'fhcp.private.quick-buttons.medical-network',
        regular: true,
        link: '/medical-network/search',
        tag: 'MEDICAL_NETWORK',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-users',
        title: 'fhcp.private.quick-buttons.beneficiaries',
        regular: true,
        link: '/beneficiaries/consult',
        tag: 'BENEFICIARIES',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-file-circle-plus',
        title: 'fhcp.private.quick-buttons.company_file_insert',
        regular: true,
        link: '/monthly-files/submit',
        tag: 'COMPANY_FILE_INSERT',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-calendar-plus',
        title: 'fhcp.private.quick-buttons.request-appointment',
        regular: true,
        link: '/book-appointment',
        tag: 'REQUEST_APPOINTMENT',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-calendar-lines',
        title: 'fhcp.private.quick-buttons.request-appointment-approval',
        regular: true,
        link: '/approve-consult',
        tag: 'REQUEST_APPOINTMENTS_APPROVAL',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-calendar-lines',
        title: 'fhcp.private.quick-buttons.request-appointments-list',
        regular: true,
        link: '/appointments/consult',
        tag: 'REQUEST_APPOINTMENTS_LIST',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-clinical-medical',
        title: 'fhcp.private.quick-buttons.home-doctor',
        regular: true,
        link: '',
        tag: 'HOME_DOCTOR',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-video',
        title: 'fhcp.private.quick-buttons.fhvc',
        regular: true,
        link: '',
        tag: 'FHVC',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-file',
        title: 'fhcp.private.quick-buttons.documents',
        regular: true,
        link: '/documents/consult',
        tag: 'DOCUMENTS',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-hand-holding-usd',
        title: 'fhcp.private.quick-buttons.refunds',
        regular: true,
        link: '/refunds/submission',
        tag: 'REFUNDS',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-user',
        title: 'fhcp.private.quick-buttons.my-data',
        regular: true,
        link: '',
        tag: 'MY_DATA',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-file',
        title: 'fhcp.private.quick-buttons.contract-data',
        regular: true,
        link: '',
        tag: 'CONTRACT_DATA',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-file',
        title: 'fhcp.private.quick-buttons.company-file-setup-information',
        regular: true,
        link: '/documents/product-info',
        tag: 'COMPANY_FILE_SETUP_INFORMATION',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-house-medical-circle-check',
        title: 'fhcp.private.quick-buttons.company-subscription',
        regular: true,
        highlight: true,
        link: 'adhesion/ZXZvbHV0aW9uX2NvbA%253D%253D/introduction',
        tag: 'COMPANY_SUBSCRIPTION',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-calculator-simple',
        title: 'fhcp.private.quick-buttons.company-simulator',
        regular: true,
        link: 'simulator/company',
        tag: 'COMPANY_SIMULATOR',
        parentTag: 'HOME'
      },
      {
        containerClass: 'col-12 mb-3',
        icon: this.appConfig.icon + ' fa-file-circle-question',
        title: 'fhcp.private.quick-buttons.company-file-setup',
        regular: true,
        link: '/documents/subscription',
        tag: 'COMPANY_FILE_SETUP',
        parentTag: 'HOME'
      }
    ];
  }

  async getQuickButtons(token: string, containerClass?: string) {
    let buttons = JSON.parse(JSON.stringify(this.listButtons));

    for (const item of buttons) {
      item.containerClass = containerClass ?? 'col-12 mb-3';
      item.visible = await this.sharedFeaturesService.exists(item.tag!, item.parentTag, token);
    }

    const homeFeatures = this.sharedFeaturesService.features.find((item) => item.parentFeatureName === 'HOME');

    if (homeFeatures?.features) {
      const orderMap: { [key: string]: { index: number; menuOrder: number } } = {};
      homeFeatures.features.forEach((feature, index) => {
        orderMap[feature.featureName] = { index, menuOrder: feature.menuOrder };
      });

      buttons.sort((a: QuickButtonsModel, b: QuickButtonsModel) => {
        const orderA = orderMap[a.tag!];
        const orderB = orderMap[b.tag!];

        if (!orderA && !orderB) return 0;
        if (!orderA) return 1;
        if (!orderB) return -1;

        if (orderA.menuOrder !== 0 || orderB.menuOrder !== 0) {
          const menuDiff = orderA.menuOrder - orderB.menuOrder;
          if (menuDiff !== 0) return menuDiff;
        }

        return orderA.index - orderB.index;
      });
    }

    return buttons;
  }

  register(data: any): Observable<any> {
    return this.http.post(this.appConfig.api + 'register', data);
  }

  updateUserData(data: any, token: string): Observable<any> {
    return this.http.put<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/person', data);
  }

  updateUserPassword(data: any): Observable<any> {
    return this.http.put<any>(this.appConfig.api + 'password', data);
  }

  getProfileInfo(): Observable<CpLoggedUserInfoModel> {
    return this.http.get<any>(this.appConfig.api + 'login/login-info').pipe(map((response) => response.body as CpLoggedUserInfoModel));
  }
}
